/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, memo, useMemo } from "react";
import useStyles from "./styles";
import keyboardObserver from "keyboard-height";
import NonCart from "./Components/NonCart";
import DialogInformation from "./Components/DialogInformation";
import DialogInformationTP from "./Components/DialogInformationTP";
import BodyCart from "./Components/BodyCart";
import FooterCart from "./Components/FooterCart";

import {
	calculateCartAction,
	setSelectProductDraftAction,
	getDataCalculateCartAction,
	setCartAction,
	setDataIdPromotionChoosesAction,
	setCalculateCartAction,
	postCreateOrderAction,
	setDefaultCartAction
} from "store/actions/OrderPageAction";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { setDeleteProductprevious } from "store/actions/GlobalAction";

const CartsPage = memo(props => {
	const classes = useStyles();
	const history = useHistory();

	const {
		carts,
		listProductDraft,
		productPrevious,
		dataCalculateCart,
		infoDataCalculate,
		infoShop,
		dispatchSetDeleteProductprevious,
		dispatchSetDataIdPromotionChooses,
		dispatchCalculateCart,
		dispatchSetSelectProductDraft,
		dispatchGetDataCalculateCart,
		dispatchSetCart,
		dispatchSetCalculateCart,
		dispatchCreateOrder,
		dispatchSetDefaultCart
	} = props;

	const [listProductOrder, setListProductOrder] = useState([]);
	const [listProductSelect, setListProductSelect] = useState([]);
	const [isShowKeyboard, setIsShowKeyboard] = useState(false);
	const [typeCreateOrder, setTypeCreateOrder] = useState("");
	const [level, setLevel] = useState("");
	const [orderId, setOrderId] = useState(0);
	const [remainingSales, setRemainingSales] = useState(0);
	const [disable, setDisable] = useState(false);
	const [heightKeyboard, setHeightKeyboard] = useState(0);
	const [open, setOpen] = useState({
		isOpen: false,
		isError: false,
		message: ""
	});
	const isAndroid = /Android/.test(navigator.userAgent);
	const business = infoShop?.business || "THOPHAT";

	keyboardObserver.on(newHeight => {
		setHeightKeyboard(newHeight);
		if (newHeight > 0) {
			setIsShowKeyboard(true);
		} else {
			setIsShowKeyboard(false);
		}
	});

	const heightFooter = document.getElementById("footerCart")?.offsetHeight;
	const heightHeaderPage =
		document.getElementById("headerPage")?.offsetHeight;

	const wallet = dataCalculateCart[`${business}`];
	const campaigns = wallet?.campaigns;

	useEffect(() => {
		const newCart = carts.map(item => ({
			id: item.id,
			business: item.business,
			totalBox: 0,
			totalDetail: 0,
			quantity: 0
		}));
		const fetchDataCarts = newCart.map(cartItem => {
			const productDraft = listProductDraft?.find(
				item => item?.id === cartItem?.id
			);
			if (cartItem.id === productDraft?.id) {
				return productDraft;
			} else {
				return cartItem;
			}
		});
		setListProductSelect(fetchDataCarts);
		setListProductOrder(carts);
		dispatchGetDataCalculateCart();
		dispatchSetDataIdPromotionChooses([]);
	}, []);

	useEffect(() => {
		if (carts.length === 0) {
			dispatchSetSelectProductDraft([]);
			dispatchSetCalculateCart({});
		}
	}, [listProductOrder]);

	// CALL API CACULATOR WHEN CHANGE PRODUCT
	useEffect(() => {
		const products = [...listProductSelect];
		if (products?.length === 0) {
			return;
		}
		const isCondition = products?.some(
			product => product?.totalBox > 0 || product?.totalDetail > 0
		);
		const isSelectProduct = products?.every(
			product => product.totalDetail === 0 && product?.totalBox
		);
		if (!isSelectProduct) {
			dispatchSetSelectProductDraft([]);
			setDisable(false);
		}
		if (!isCondition) {
			dispatchSetCalculateCart({});
			return;
		}
		if (!isShowKeyboard) {
			handleOrder();
		}
	}, [listProductSelect, isShowKeyboard]);

	const handleDeleteProduct = item => {
		const newListProduct = listProductOrder.filter(
			product => product.id !== item.id
		);
		const newProductPrevious = productPrevious?.filter(
			product => product?.id !== item.id
		);
		dispatchSetDeleteProductprevious(newProductPrevious);
		setListProductOrder(newListProduct);
		dispatchSetCart(newListProduct);
		const newListSelect = listProductSelect.filter(el => el.id !== item.id);
		setListProductSelect(newListSelect);
		dispatchSetSelectProductDraft(newListSelect);
	};

	const handleOrder = () => {
		let arr = [];
		listProductSelect.forEach(item => {
			if (arr.find(el => el === item.business)) {
				return;
			} else {
				arr.push(item.business);
			}
		});
		let dataCalculateCart = {};
		let newList = [];
		arr.forEach(item => {
			const listFollowItem = listProductSelect.filter(
				el => el.business === item
			);
			const data = listFollowItem.map(el => {
				const cartItem = carts.find(item => item.id === el.id);
				const quantity =
					el.totalBox * cartItem.maxUnitQuantity + el.totalDetail;
				return {
					productId: el.id,
					quantity: quantity
				};
			});
			newList.push(
				listFollowItem.map(el => {
					const cartItem = carts.find(item => item.id === el.id);
					const quantity =
						el.totalBox * cartItem.maxUnitQuantity + el.totalDetail;
					return { ...el, quantity: quantity };
				})
			);
			const cartItems = data?.filter(product => product?.quantity !== 0);
			setDisable(listProductSelect?.length === cartItems?.length);
			dataCalculateCart[`${item}`] = {
				cartItems: cartItems
			};
		});
		dispatchSetSelectProductDraft(newList.flat());
		const dataSubmit = {
			dataCalculateCart,
			onFail: () => {
				if (
					listProductSelect?.length ===
					dataCalculateCart[`${business}`]?.cartItems?.length
				) {
					setDisable(false);
				}
			},
			onSuccess: () => {
				if (
					listProductSelect?.length ===
					dataCalculateCart[`${business}`]?.cartItems?.length
				) {
					setDisable(true);
				}
			}
		};
		dispatchCalculateCart(dataSubmit);
	};

	const onSuccess = data => {
		const { crmLevel, orderId, remainingSales } = data;
		setTypeCreateOrder("SUCCESS");
		setOrderId(orderId);
		setLevel(crmLevel);
		setRemainingSales(remainingSales);
		setOpen({
			isOpen: true,
			isError: false,
			message: ""
		});
	};

	const onFail = message => {
		setTypeCreateOrder("FAIL");
		setOpen({
			isOpen: true,
			isError: true,
			message: message
		});
	};

	const handleBuy = () => {
		const dataBusiness = dataCalculateCart[`${business}`];
		const promotions = dataBusiness?.campaigns
			?.map(item => item.promotions)
			.flat();
		const newList = promotions?.map(item => {
			if (
				item.type === "PROMOTION_ITEM_QUANTITY_GIFT" ||
				item.type === "PROMOTION_ITEM_AMOUNT_GIFT"
			) {
				const list = item.groups.map(group => {
					return {
						...group,
						products: group.products.map((product, index) => ({
							distributorInventoryQuantity:
								product.distributorInventoryQuantity,
							id: product.id,
							image: product.image,
							name: product.name,
							salemanInventoryQuantity:
								product.salemanInventoryQuantity,
							stock: product.stock,
							quantity: index === 0 ? group?.quantity : 0 //lấy sản phẩm đầu tiên
						}))
					};
				});
				return { ...item, groups: list };
			} else {
				return { ...item };
			}
		});

		const loyaltys = dataBusiness?.loyaltys?.map(item => {
			const rewardGifts = item.rewardGifts.map(rewardGift => ({
				level: rewardGift.level,
				quantity: rewardGift.quantity ? rewardGift.quantity : 0
			}));
			return {
				id: item.id,
				rewardGifts: rewardGifts
			};
		});

		const dataSubmit = {
			delivery: {
				address: infoDataCalculate?.shopAddress,
				phone: infoDataCalculate?.shopPhone,
				name: infoDataCalculate?.shopName
			},
			note: "",
			carts: {
				totalAmount: dataBusiness?.totalAmount,
				promotions: newList,
				finalAmount: dataBusiness?.finalAmount,
				finalDiscount: dataBusiness?.finalDiscount,
				items: listProductDraft
					.filter(item => item.business === business)
					?.map(el => ({
						quantity: el.quantity,
						productId: el.id
					})),
				loyaltys: loyaltys
			},
			taxCode: ""
		};

		const data = {
			dataCreate: { [`${business}`]: dataSubmit },
			business,
			onSuccess,
			onFail
		};
		setDisable(false);
		dispatchCreateOrder(data);
	};

	const closeDialog = () => {
		dispatchSetCalculateCart({});
		setOpen({
			isOpen: false,
			isError: false,
			message: ""
		});
	};

	const handleClose = () => {
		closeDialog();
		dispatchSetCalculateCart({});
		if (typeCreateOrder === "SUCCESS") {
			history.push("/home");
			dispatchSetDefaultCart(typeCreateOrder);
		}
	};

	const handleWatchOrder = () => {
		closeDialog();
		history.push(`/order_history_detail?id=${orderId}&business=TAC`);
		dispatchSetDefaultCart(typeCreateOrder);
	};

	const handleHome = () => {
		closeDialog();
		dispatchSetCalculateCart({});
		history.push("/home");
		dispatchSetDefaultCart(typeCreateOrder);
	};

	const handleTryAgain = () => {
		setOpen({
			isOpen: false,
			isError: false,
			message: ""
		});
		setDisable(true);
	};

	const handleOnFocus = () => {
		setTimeout(() => {
			if (isShowKeyboard) {
				setIsShowKeyboard(false);
			}
		}, 500);
	};

	const heightWrapperCart = useMemo(() => {
		return (
			heightHeaderPage +
			(!!heightKeyboard
				? isAndroid
					? 10
					: heightKeyboard
				: heightFooter)
		);
	}, [heightKeyboard, heightHeaderPage, heightFooter, isAndroid]);

	return (
		<Grid
			classes={{ root: classes.root }}
			style={{
				height: `calc(100vh - ${heightHeaderPage}px)`
			}}
			onClick={() => {
				handleOnFocus();
			}}
		>
			{carts?.length > 0 ? (
				<React.Fragment>
					<BodyCart
						handleOnFocus={handleOnFocus}
						heightWrapperCart={heightWrapperCart}
						wallet={wallet}
						listProductOrder={listProductOrder}
						listProductSelect={listProductSelect}
						setListProductSelect={setListProductSelect}
						handleDeleteProduct={handleDeleteProduct}
						isShowKeyboard={isShowKeyboard}
						setIsShowKeyboard={setIsShowKeyboard}
						campaigns={campaigns}
					/>
					<FooterCart
						isShowKeyboard={isShowKeyboard}
						wallet={wallet}
						disable={disable}
						handleBuy={handleBuy}
					/>
				</React.Fragment>
			) : (
				<NonCart height={`calc(100vh - ${heightHeaderPage}px)`} />
			)}
			{business === "THOPHAT" ? (
				<DialogInformationTP
					open={open}
					handleWatchOrder={handleWatchOrder}
					handleClose={handleClose}
					handleHome={handleHome}
					handleTryAgain={handleTryAgain}
				/>
			) : (
				<DialogInformation
					open={open}
					type={level}
					money={remainingSales}
					handleWatchOrder={handleWatchOrder}
					handleClose={handleClose}
					handleHome={handleHome}
					handleTryAgain={handleTryAgain}
				/>
			)}
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		listProductDraft: state.orderPageReducer.listProductDraft,
		carts: state.orderPageReducer.carts,
		productPrevious: state.globalReducer.productPrevious,
		dataCalculateCart: state.orderPageReducer.dataCalculateCart,
		infoDataCalculate: state.orderPageReducer.infoDataCalculate,
		infoShop: state.homePageReducer.infoShop
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchCalculateCart: data => {
			dispatch(calculateCartAction(data));
		},
		dispatchSetSelectProductDraft: data => {
			dispatch(setSelectProductDraftAction(data));
		},
		dispatchGetDataCalculateCart: () => {
			dispatch(getDataCalculateCartAction());
		},
		dispatchSetCart: params => {
			dispatch(setCartAction(params));
		},
		dispatchSetDeleteProductprevious: product => {
			dispatch(setDeleteProductprevious(product));
		},
		dispatchSetDataIdPromotionChooses: data => {
			dispatch(setDataIdPromotionChoosesAction(data));
		},
		dispatchSetCalculateCart: data => {
			dispatch(setCalculateCartAction(data));
		},
		dispatchCreateOrder: data => {
			dispatch(postCreateOrderAction(data));
		},
		dispatchSetDefaultCart: data => {
			dispatch(setDefaultCartAction(data));
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(CartsPage);
